import { isUserChartTileUrl, resolveUserChartTileUrl } from '@/data/UserChartRepository/userChartTileStore'

// Mapbox GL JS `transformRequest` hook. Mapbox has no addProtocol (a MapLibre
// feature), so user-chart tiles are served by rewriting their sentinel URLs
// (`https://userchart.tiles/...`) to the in-memory blob object URL for each tile.
// Returns undefined for everything else so Mapbox handles normal requests.
export function userChartTransformRequest(url: string): { url: string } | undefined {
  if (isUserChartTileUrl(url)) {
    return { url: resolveUserChartTileUrl(url) }
  }
  return undefined
}
